import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { DckSelectors, DckActionCreators } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../lib/Authenticated"
import SingleSelectTable from "../fragments/SingleSelectTable"
import AlertModal from "../fragments/AlertModal"
import ProcessesStatus from "../fragments/ProcessesStatus"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { getChargeAmount, sortDate, sortNumber } from "../../lib/utils"
import UIAvatar from "../fragments/UIAvatar"
import ClearFiltersButton from "../fragments/ClearFiltersButton"

class ListCharges extends Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    charge: null,
    running: false,
    success: false,
    error: null,
  }

  componentDidMount() {
    this.props.loadCharges()
  }

  handleDelete = charge => this.setState({
    charge,
    running: false,
    success: false,
    error: null
  })

  confirmDeleteCharge = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { charge: { id: chargeId } } = this.state

    blockingFetchService(
      accessToken => apiServerApi.deleteLoanCharge(accessToken, chargeId),
      _ => {
        this.setState({ success: true })
        this.props.loadCharges()
        setTimeout(this.closeDeleteForm, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeDeleteForm = () => this.setState({ charge: null })

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.currencyCode.cleanFiltered()
    this.refs.chargeTimeTypeText.cleanFiltered()
    this.refs.chargeCalculationTypeText.cleanFiltered()
    this.refs.amount.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
    this.refs.active.cleanFiltered()
  }

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state
    return (
      <div>
        <h3>Are you sure you want to delete this charge?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderUpdateLink = chargeId => {

    if(!this.isAdmin) return null
    return (
      <Link to={`/charges/${chargeId}/update`} className='p-5'>
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  render() {
    const { charges } = this.props,
    { charge, running } = this.state

    return (
      <div>

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <SingleSelectTable
          items={ charges }
          addNewLabel="New Charge"
          addNewHandler={() => browserHistory.push("/charges/create")}
          handleDelete={ this.handleDelete }
          deleteLabel='Delete'
          disableDelete={() => false}
          shouldRenderToolbar={ this.isAdmin }
          exportCSV={ this.isAdmin }
          csvFileName='Charges.csv'
        >
          <TableHeaderColumn
            dataField="id"
            isKey
            dataAlign="center"
            dataFormat={(_, row) => <UIAvatar name={ row.name } size={ 28 } />}
            csvHeader="Charge ID"
            width='48'
          />

          <TableHeaderColumn
            ref="name"
            dataField="name"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={(name, row) =>
              <Link to={`/charges/${row.id}/detail`} title='Show details'>{ name }</Link>}
            csvHeader="Name"
            columnClassName="min-w-120"
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="currencyCode"
            dataField="currencyCode"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataAlign="center"
            csvHeader="Currency"
            columnClassName="min-w-120"
          >
            Currency
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="chargeTimeTypeText"
            dataField="chargeTimeTypeText"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Charge Time Type"
            columnClassName="min-w-120"
          >
            Charge Time Type
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="chargeCalculationTypeText"
            dataField="chargeCalculationTypeText"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Charge Calculation Type"
            columnClassName="min-w-120"
          >
            Charge Calculation Type
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="amount"
            dataField="amount"
            dataSort
            sortFunc={(a, b, order) => sortNumber(a.amount, b.amount, order)}
            dataFormat={(amount, { chargeCalculationType, currencyCode }) =>
              getChargeAmount({ amount, chargeCalculationType, currencyCode })
            }
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Amount"
            columnClassName="min-w-120"
          >
            Amount
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="createdOnFormatted"
            dataField="createdOnFormatted"
            dataAlign="center"
            dataSort
            sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Created On"
            columnClassName='text-xs'
            width="140"
          >
            Created On
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="active"
            dataField="active"
            dataAlign="center"
            dataSort
            width="90"
            tdStyle={{ verticalAlign: 'middle' }}
            csvHeader="Active"
            dataFormat={(active, row) => <FontAwesome
              title={ active ? 'Active' : 'Inactive' } 
              style={{ color: active ? 'green' : '#a66' }} 
              name={ active ? 'check' : 'close' } />
            }>
            Active
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            width="80"
            dataFormat={(_, row) =>
              <span className="flex-detail">
                <Link to={`/charges/${row.id}/detail`} className='p-5'>
                  <FontAwesome name="eye" title='View' />
                </Link>
                { this.renderUpdateLink(row.id) }
              </span>
            }
          />
        </SingleSelectTable>

        <AlertModal
          show={ charge != null }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDeleteCharge }
          proceedText="Delete"
          disabled={ running }
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const charges = DckSelectors.selectAllItems(state, ItemTypes.Charges)
  return { charges }
},

mapDispatchToProps = dispatch => ({
  loadCharges: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Charges)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListCharges)



// WEBPACK FOOTER //
// ./src/components/Charges/List.js